import type { ReactElement } from "react";

import type Question from "metabase-lib/v1/Question";

import { HeadBreadcrumbs } from "../HeaderBreadcrumbs/HeaderBreadcrumbs";

import { getDataSourceParts } from "./utils";

interface Props {
  className?: string;
  divider?: ReactElement | string;
  question: Question;
  variant: "head" | "subhead";
  isObjectDetail?: boolean;
  isAdmin?: boolean; // CIQ Edit: hide database/schema links for non-admins
}

export function DataSourceCrumbs({
  question,
  variant,
  isObjectDetail,
  isAdmin, // CIQ Edit: hide database/schema links for non-admins
  ...props
}: Props) {
  const parts = getDataSourceParts({
    question,
    subHead: variant === "subhead",
    isObjectDetail,
    isAdmin, // CIQ Edit: hide database/schema links for non-admins
  });

  return <HeadBreadcrumbs parts={parts} variant={variant} {...props} />;
}
